import '../../css/global/app.css';
import '../../css/pdp.css';

// import Swiper styles
import '../../../node_modules/swiper/swiper.min.css';

import { swiper } from '../swiper';
import { journal } from '../journal';
import { pdp } from '../pdp';
import { pages } from '../pages';
import { footer } from '../footer';
import { collections } from '../collections';
import { header } from '../header';

document.addEventListener('DOMContentLoaded', function () {
  const checkProductInfoContainer = document.querySelector(
    '.product__info-wrapper'
  );
  header();
  swiper();
  pages();
  if (checkProductInfoContainer) {
    pdp();
  }
  collections();
  journal();
  footer();
});
